import { NavLink, useLocation, useParams } from "react-router-dom";
import tw from "twin.macro";

const Tab = tw(
  NavLink
)` relative flex items-center gap-x-3 px-6 py-4 text-sm font-semibold transition text-gray-600 border-b  `;

const ClientTabs = () => {
  const { clientId } = useParams();
  const { pathname } = useLocation();
  const currentPath = pathname;

  const tabs = [
    { name: "Informations", to: `/clients/${clientId}/informations` },
    { name: "Utilisateurs", to: `/clients/${clientId}/team-members` },
    { name: "Gestion de zones", to: `/clients/${clientId}/areas` },
  ];

  return (
    <nav css={tw`w-fit flex border-b`}>
      {tabs.map((tab) => renderTab(tab, currentPath))}
    </nav>
  );
};

export const renderTab = (
  tab: { name: string; to: string },
  currentPath: string
) => {
  return (
    <Tab
      key={tab.name}
      to={tab.to}
      css={[
        tw`px-4`,
        currentPath === tab.to
          ? tw`text-primary-700 border-b-2  border-primary-700`
          : tw`hover:(text-gray-900 border-b border-b-gray-400)`,
      ]}
    >
      {tab.name}
    </Tab>
  );
};

export default ClientTabs;
